import React, {useContext, useState, useEffect} from "react";

import AuthenticationService from "../services/AuthenticationService";
import {NotificationsContext} from "../ui-components/Notifications";
import apiRequest from "../services/apiRequest";
import {useIntl} from "react-intl";
import _ from "lodash";

import ConnectionsTable from "../components/Tables/ConnectionsTable";
import {PageHeading} from "../ui-components/Container";
import Placeholder from "../ui-components/Placeholder";
import useRoles from "../ui-components/pages/Users/hooks/useRoles";
import {PRIVILEGED_ROLES} from "../constants";
import {useSalesAndFields} from "@hooks/useSalesAndFields";
import CountryContext from "../CountryContext";

const Connections = () => {

  const {
    country: {code: countryCode}
  } = useContext(CountryContext);

  const {push} = useContext(NotificationsContext);
  const userData = AuthenticationService.getUserData();
  const roleType = userData.role_type;
  const privilegedRolesExtended = [...PRIVILEGED_ROLES, ...(countryCode === "es" ? ["field"] : [])]
  const perm = privilegedRolesExtended.includes(roleType) ? roleType : `user_${userData.id}`;
  const roles = useRoles();

  const [total, setTotal] = useState();

  const intl = useIntl();

  const {sales, fields} = useSalesAndFields();

  return (
    <div className="min-h-full pt-4 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center w-full mx-auto">
        <PageHeading
          title={intl.formatMessage({id: "connections"})}
          contentActions={
            total ? (
              <div className="font-2xl font-bold border border-black rounded-3xl py-3 px-5">
                {total}
              </div>
            ) : null
          }
        />
        {!sales || !fields ? (
          <div className="flex flex-col w-full mb-4">
            <Placeholder
              height="h-20"
              classNames={`rounded-lg bg-${userData.business}-400`}
            />
            <Placeholder height="h-10" classNames="rounded-lg my-4"/>
            <Placeholder height="h-96" classNames="rounded-lg"/>
          </div>
        ) : (
          <div>
            <ConnectionsTable
              setTotal={setTotal}
              sales={sales}
              fields={fields}
              intl={intl}
              perm={perm}
              roles={roles}
            />
          </div>
        )}
      </main>
    </div>
  );
};

export default Connections;
